quoteModule.controller('quoteScenariosController',
    ['$scope','$rootScope', 'quoteCreationEvents', 'rateQuoteCoordService', '$q',
        'rateQuoteScenariosService','rateQuotePersistService', '$mdDialog','contractCreationService','$location',
        'erateSessionVarsService','quoteIntegrationConstants','TLCError','AppErrorCodes', 'vehicleProductCoordService',
    function ($scope, $rootScope, quoteCreationEvents, rateQuoteCoordService, $q,
        rateQuoteScenariosService, rateQuotePersistService, $mdDialog, contractCreationService, $location,
        erateSessionVarsService, quoteIntegrationConstants,TLCError,AppErrorCodes, vehicleProductCoordService) {
        /*
        Scenarios have been "renamed" as "proposals" in the UI, but I didn't want to change the internal names.
        This controller keeps track of the current proposals including creating a new proposal, copying an existing
        proposal, and removing a proposal. Finalizing a scenario/proposal removes all the others and. Anytime we
        make changes we attempt to persist them.
         */

        var self = this;
        //data to show in the view
        $scope.scenarioInfo = {
            chosenScenario : 1,
            scenarioQuotes : [],
            showDialog : false,
            hideScenarioButtons : true
        };
        $scope.quotingModeQS = null;
        $scope.menuQuoteIntegrated = quoteIntegrationConstants.menuQuoteIntegrated;
        $scope.menuContractIntegrated = quoteIntegrationConstants.menuContractIntegrated;
        $scope.printerText = 'Print Quotes';
        $scope.showClosePrinter = false;

        //initialize the directive with the controller
        this.init = function (element) {
            $scope.quotingModeQS = erateSessionVarsService.getQuotingMode();
            if ($location.search()['qsession'])
                contractCreationService.waitForContractChecks();
            $scope.scenarioInfo.hideScenarioButtons = true;
            self.$element = element;
            $scope.scenarioInfo.chosenScenario =
                rateQuoteScenariosService.getCurrentScenario();
            $scope.loadScenarioQuotes();
            $scope.printerText = 'Print Quotes';
            $scope.showClosePrinter = false;
        }

        //initialize the scenario view data
        $scope.initScenarioInfo = function(){
            $scope.scenarioInfo = {
                chosenScenario : 1,
                scenarioQuotes : [],
                showDialog : false,
                hideScenarioButtons : true
            };
            $scope.loadScenarioQuotes();
        }
        $scope.contractsProcessing = contractCreationService.contractsProcessing;

        //show/hide "clone" window
        $scope.toggleShowDialog = function(){
            $scope.scenarioInfo.showDialog = !$scope.scenarioInfo.showDialog;
            $scope.scenarioInfo.chosenScenario = 0;
            $scope.changeCurrentScenario();
        }
        //get all of the scenarios
        $scope.getAllScenarios = function(){
            return rateQuoteScenariosService.getScenarioList();
        }
        //set current scenario
        $scope.setScenario = function(scenarioId){
            rateQuoteScenariosService.setCurrentScenario(scenarioId);
            $rootScope.$broadcast(quoteCreationEvents.scenarioChanged,{});
        }
        //change the current scenario
        $scope.changeCurrentScenario = function(){
            $scope.loadScenarioQuotes();
        }
        //get quotes for a scenario (for clone view)
        $scope.loadScenarioQuotes = function(){
            $scope.scenarioInfo.initShowButtons = false;
            if ($scope.scenarioInfo.chosenScenario == 0)//haven't picked a scenario to clone yet
                return;
            $scope.scenarioInfo.scenarioQuotes =  rateQuoteCoordService.getRatesForScenarioCode(parseInt($scope.scenarioInfo.chosenScenario));
            if ($scope.scenarioInfo.scenarioQuotes && $scope.scenarioInfo.scenarioQuotes.length > 0){
                $scope.scenarioInfo.scenarioQuotes.sort(function sortQuotes(a,b){
                    if (a.RatedProduct.ParentProductType.ParentProductRatingCategory.ApplicationCode.toUpperCase() <
                        b.RatedProduct.ParentProductType.ParentProductRatingCategory.ApplicationCode.toUpperCase()){ return -1;}
                    if (a.RatedProduct.ParentProductType.ParentProductRatingCategory.ApplicationCode.toUpperCase() >
                        b.RatedProduct.ParentProductType.ParentProductRatingCategory.ApplicationCode.toUpperCase()){ return 1;}
                    return 0;
                })
            }
            else
                contractCreationService.clearContractsChecks();//no quotes, so no contracts either

            $scope.scenarioInfo.hideScenarioButtons = false;
        }
        //blank scenario
        $scope.newScenario = function(){
            try {
                rateQuoteCoordService.addNewScenario();
                var scens = rateQuoteScenariosService.getScenarioList();
                $scope.setScenario(scens[scens.length - 1]);
                scens = null;
            }
            catch(e){
                throw new TLCError(new Error(e),AppErrorCodes.QuoteScenarioController_GeneralError);
            }
        }

        $scope.copyScenario = function(val){
            try {
                $scope.scenarioInfo.chosenScenario = val;
                rateQuoteCoordService.addNewScenario(parseInt($scope.scenarioInfo.chosenScenario));
                var scens = rateQuoteScenariosService.getScenarioList();
                $scope.setScenario(scens[scens.length - 1]);
                $rootScope.$broadcast(quoteCreationEvents.attemptQuoteSave,{});
                if ($scope.scenarioInfo.showDialog)
                    $scope.toggleShowDialog();
                scens = null;
            }
            catch(e){
                throw new TLCError(new Error(e),AppErrorCodes.QuoteScenarioController_GeneralError);
            }
        }
        //remove a scenario
        $scope.removeScenario = function(scenarioId){
            rateQuotePersistService.removeQuoteScenario(scenarioId)
            .then(
            function(msg){
                var scens = rateQuoteScenariosService.getScenarioList();
                $scope.setScenario(scens[0]);
                $rootScope.$broadcast(quoteCreationEvents.quoteRemovedFromScenario,{});
            },
            function(err){
                throw new TLCError(new Error(err),AppErrorCodes.QuoteScenarioController_GeneralError);
            });
        }
        //need to get this from settings
        $scope.getModifyRetailAllowed = function(productCategoryCode){
            return true;
        }
        //need to get this from settings
        $scope.getShowProfitCost = function(productCategoryCode){
            return true;
        }
        //remove quotes
        $scope.$on(quoteCreationEvents.removeCurrentQuotes, function(event, args) {
            var scenarios = angular.copy(rateQuoteScenariosService.getScenarioList());

            scenarios.forEach(
                function(nxtScenario) {
                    rateQuotePersistService.removeQuoteScenario(nxtScenario)
                    .then(
                    function(msg){
                    },
                    function(err){
                        throw new TLCError(new Error(err),AppErrorCodes.QuoteScenarioController_GeneralError);
                    });
                }
            );
            $scope.initScenarioInfo()
        });
        //mark a scenario as final by removing others
        $scope.finalizeScenario = function(scenarioId){
            var scenarios = angular.copy(rateQuoteScenariosService.getScenarioList());

            scenarios.forEach(
                function(nxtScenario) {
                    if (parseInt(nxtScenario) != parseInt(scenarioId)){
                        rateQuotePersistService.removeQuoteScenario(nxtScenario)
                        .then(
                        function(msg){
                        },
                        function(err){
                            throw new TLCError(new Error(err),AppErrorCodes.QuoteScenarioController_GeneralError);
                        });
                    }
                }
            );
            $rootScope.$broadcast(quoteCreationEvents.attemptQuoteSave,{});
        };

        //Displays clone modal
        // Displays product settings dialog-box.
        $scope.showScenarios = function(event, scenarios, copyScenarios) {
            $mdDialog.show( {
                controller: 'proposalCloneDialogController',
                templateUrl: 'app/modules/quote/views/proposal-clone-dialog.html',
                parent: angular.element(document.body),
                targetEvent: event,
                controllerAs: 'ctrl',
                bindToController: true,
                locals: {
                    scenarios: scenarios,
                    copyScenarios: copyScenarios
                }

            });

            if (event) {
                event.stopPropagation();
            }
        };


        //refresh the quote queue and get current scenario
        $scope.$on(quoteCreationEvents.scenarioChanged, function(event, args) {
            $scope.scenarioInfo.chosenScenario = rateQuoteScenariosService.getCurrentScenario();
        });

        $scope.showPrintDiv = function() {
            $scope.showClosePrinter = true;
            $rootScope.$broadcast(quoteCreationEvents.showPrinterOnDiv,{printAction: $scope.printerText});
        };

        $scope.closePrintDiv = function() {
            $rootScope.$broadcast(quoteCreationEvents.showPrinterOnDiv,{printAction: "Close"});
            $scope.showClosePrinter = false;
            $scope.printerText = 'Print Quotes';
        };

        $scope.$on(quoteCreationEvents.divSelectedToPrint, function(event,args){
            if (args.printerText  != "Close")
                $scope.printerText = args.printerText;
            else
                $scope.closePrintDiv();
        });

        // UI Variable that tells the 'Print Quotes' button if we have any products or not - Used to disable print button
	    $scope.productsArrayLength = 0; //vehicleProductCoordService.allProductData().length;

	    $scope.$on(quoteCreationEvents.productDataComplete, function(){
		    $scope.productsArrayLength = vehicleProductCoordService.allProductData().length;
	    });

}]);
